"use client";
import { useGSAP } from "@gsap/react";
import Feature from "./Feature";
import gsap from "gsap/all";

function Features({ mainFeatures }) {
  useGSAP(() => {
    gsap.from(".feature", {
      opacity: 0,
      duration: 1,
      stagger: 1,
      ease: "power1.in",
    });
  });

  return (
    <div className="space-y-6 pb-6 pt-10">
      {mainFeatures.map((f, i) => (
        <Feature key={231 + i} f={f} />
      ))}
    </div>
  );
}

export default Features;
